import UI from "./base/UI";
import {gsap, Power0} from 'gsap';
import {getInputButtonClose} from "./templates/html.template";
import { 
    isA11yCheckVersion,
} from "../functions/a11y.ui";
import Popup from "./base/Popup";

/**
 * Calculator
 */

 /**
#### HTML 구조 및 Data 속성 참고 페이지
** [http://172.20.160.28:9700/kbank_html_mmk/pbk/html/pbc/PBKPBC0000000100S.html?popup=2](http://172.20.160.28:9700/kbank_html_mmk/pbk/html/pbc/PBKPBC0000000100S.html?popup=2)
*/
class Calculator extends UI {
    defaults = {
        activeIndex: null,
        calcInpLen: 0,
    };
    isA11yEventStatus = true;
    
    inputGroupTitle = []; // A11YTASK-222 : 접근성대응(2025-03-18)

    constructor(el, options) {
        super('Calculator', el);

        this.init(el, options);
    }

    

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        this.inputGroupTitle = Array.from(document.querySelectorAll('.input-txt-group')).map(div => div.title); // A11YTASK-222 : 접근성대응(2025-03-18)
        this.render();
    }   
    render() { 
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');

        if (!this.$el.find('.calc-input .fake-input').length > 0) { // 240527 제외  접근성작업
            this.$el.find('.calc-input').each(function(index,element){
                $(element).attr('calc-input-num',index);
                $numberPad.prepend(`<input type="hidden" calc-input-hidden="${index}" calc-title="${$(element).find('.label-field').text()}입력, ${$(element).find('input').attr('placeholder')}">`)
                if ($(element).find('input').val() != ''){
                    $(element).addClass('done');
                    $(element).append(`<div class="fake-input calc-number" aria-hidden="true"><div class="txt">${that.commaSet($(element).find('input').val())}</div></div>`)
                    $(element).attr('input-check', true)
                    if ($(element).find('input').next('.btn-delete-txt').length <= 0) {
                        $(element).find('input').after(getInputButtonClose());
                        if (!$(element).hasClass('active')) {
                            $(element).find('input').next('.btn-delete-txt').addClass('hidden')
                        }
                    }
                    
                    // 250620 A11YTASK-640 주석처리
                    // $(element).removeAttr('title'); // A11YTASK-222 : 접근성대응(2025-03-18)
    
                    // A11YTASK-504 : 접근성 대응 (2025.05.19)
                    if(isA11yCheckVersion()){
                        const inputValue = $(element).find('input').val();
                        const numCommaVal = that.commaSet(inputValue);//A11YTASK-156 :접근성 대응
                        const inputRightTxt = $(element).find('.txt-field').text();
                        
                        // 250620 A11YTASK-640 주석처리
                        // $(element).attr('aria-label', numCommaVal + inputRightTxt +' '+ that.inputGroupTitle[index] ) //A11YTASK-504 : 접근성대응(2025-4-28)

                        // 250620 A11YTASK-640 aria-label 함수 호출
                        that.addAriaLabel($(element),index,numCommaVal+inputRightTxt+' ');
                    }
                } else {
                    $(element).append(`<div class="fake-input calc-number" aria-hidden="true"><div class="txt"></div></div>`)
                    $(element).attr('input-check', false);
                    
                    // 250620 A11YTASK-640 주석처리
                    // $(element).removeAttr('aria-label'); // A11YTASK-222 : 접근성대응(2025-03-18)

                    if(isA11yCheckVersion()){
                        // 250620 A11YTASK-640 aria-label 함수 호출
                        that.addAriaLabel($(element),index);
                    }
                }
            });

            // $numberPad.prepend('<div tabindex="0" class="focus-txt hide-txt"></div>')  // 240527 제외  접근성작업
            this.defaults.calcInpLen = this.$el.find('.calc-input').length;
            if ($numberPad.find('.popup-section .popup-content .close-btn').length > 0 ) {
                $numberPad.find('.popup-section .popup-content .close-btn').remove();
            }
            
            /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
            if(isA11yCheckVersion()){
                const keypadCaptionText = $numberPad.find('.keypad-table caption').text();

                if ($numberPad.find('.popup-section .popup-content .numberpad-close-btn').length == 0) {
                    // A11YTASK-219 순차탐색 포커싱을 위해 z-index:-999 삭제
                    $numberPad.find('.popup-section .popup-content')?.before(`<a href="javascript:void(0);" role="button" title="넘버패드 팝업 닫기" tabindex="0" class="numberpad-close-btn" style="position: absolute; z-index:1; top: 0px; left: 0px; width: 100%; height: 100%;"></a>`);
                    $numberPad.find('.popup-section .popup-content')?.css({'position':'relative', 'z-index':'2'});
                    $numberPad.find('.popup-section .popup-footer')?.css({'position':'relative','z-index':'2'});
                }
    
                //$numberPad.find('.focus-txt.hide-txt').attr({'aria-hidden':'true'});  // 240527 제외  접근성작업
                //pad ios caption버그로 초점이동 안되는 현상 대응
                this.a11yNumPadCaption();
    
                //각 공모주 input영역에 실시간 변화시 텍스트 읽어주는 속성
                $('[calc-input-num]').attr({'aria-live':'assertive', 'aria-atomic':'false', 'aria-relevant':'additions text'});
                $('[calc-input-num]').find('.txt-field').attr('aria-hidden','true');
    
                this.$el.find('.calc-numberpad.popup-calc .numberpad-close-btn').attr({'title':'keypad 닫기'})
            }
            /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
    
            this.attachEvents();
        }
       
    }
    /**
    * ui-calc 리셋
    * @example 
    * $('.ui-calc').data('ui').reset();
    */
    reset(){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        this.$el.find('.calc-input').each(function(index,element){
            $(element).find('input').val('').removeAttr('value')
            $(element).removeClass('active done');
            if ($(element).find('.fake-input').length > 0) {
                $(element).find('.fake-input .txt').text('')
            }
            if ($(element).find('input').next('.btn-delete-txt').length > 0) {
                $(element).find('input').next('.btn-delete-txt').addClass('hidden')
            }
            // A11YTASK-222 aria-label 초기화 추가
            $(element).removeAttr('aria-label');
            $(element).attr('input-check', false);
            that.nextBtnCheck(index)
        });
    }
    initSetting(){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        this.$el.find('.calc-input').each(function(index,element){
            console.log('initSettion');
            console.log($(element).find('input').val());
            if ($(element).find('input').val() != ''){
                $(element).addClass('done');
                if ($(element).find('.fake-input').length > 0) {
                    console.log('initSetting', $(element).find('input').val())
                    $(element).find('.fake-input .txt').text(that.commaSet($(element).find('input').val()))
                }
                if ($(element).find('input').next('.btn-delete-txt').length <= 0) {
                    $(element).find('input').after(getInputButtonClose());
                    if (!$(element).hasClass('active')) {
                        $(element).find('input').next('.btn-delete-txt').addClass('hidden')
                    }
                }
                $(element).attr('input-check', true);
                $(element).removeAttr('title'); // A11YTASK-222 : 접근성대응(2025-03-18)
                // A11YTASK-222 value값 셋팅 추가
                $(element).find('input').attr('value', $(element).find('input').val());
                that.nextBtnCheck(index);
                
                // A11YTASK-504 : 접근성 대응 (2025.05.19)
                if(isA11yCheckVersion()){
                    const inputValue = $(element).find('input').val();
                    const numCommaVal = that.commaSet(inputValue);
                    const inputRightTxt = $(element).find('.txt-field').text();

                    // 250620 A11YTASK-640 주석처리
                    // $(element).attr('aria-label', numCommaVal + inputRightTxt +' '+ that.inputGroupTitle[index] )

                    // 250620 A11YTASK-640 aria-label 함수 호출
                    that.addAriaLabel($(element),index,numCommaVal+inputRightTxt+' ');
                }
            } else {
                $(element).attr('input-check', false);
                if(isA11yCheckVersion()){
                    // 250620 A11YTASK-640 aria-label 함수 호출
                    that.addAriaLabel($(element),index);
                }
            }
        });
        that.btnDeleteChk();
    }


    // 250620 A11YTASK-640 aria-label 함수 추가
    addAriaLabel(target,index,value){
        setTimeout(()=>{
            const elTitle = target.attr('title'),
            elText =  target.find('label').text(), placeHolder = target.find('input').attr('placeholder');
            if(elTitle && elTitle !='') target.removeAttr('title');
            if(index === 0 && elText.match('공모가')) target.attr('aria-label',`${value && value !='' ? value : ''}공모가를 입력해주세요${placeHolder && placeHolder != '' ? `(${placeHolder})` : ''}`);
            if(index === 1 && elText.match('증거금 비율')) target.attr('aria-label',`${value && value !='' ? value : ''}증거금 비율을 입력해주세요${placeHolder && placeHolder != '' ? `(${placeHolder})` : ''}`);
            if(index === 2 && elText.match('경쟁률')) target.attr('aria-label',`${value && value !='' ? value : ''}경쟁률을 입력해주세요${placeHolder && placeHolder != '' ? `(${placeHolder})` : ''}`);
            if(index === 3 && elText.match('입금액')) target.attr('aria-label',`${value && value !='' ? value : ''}입금액을 입력해주세요${placeHolder && placeHolder != '' ? `(${placeHolder})` : ''}`);
        },200);
    }

    attachEvents () {
        const that = this;

        this.$el.find('.calc-input').on('focus', function(e){
            //e.stopPropagation();
            //e.preventDefault();
            that.defaults.activeIndex = $(this).attr('calc-input-num');
            that.$el.find('.calc-input').each((idx,el)=>{
                if (idx == that.defaults.activeIndex ) {
                    that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`).addClass('active')
                } else {
                    $(el).removeClass('active')
                }
            })
            const $numberPad = that.$el.find('.calc-numberpad');
            // A11YTASK-222 넘패드 닫히는거 방지
            // if (isA11yCheckVersion()) {
            //     if ($numberPad.hasClass('on')) {
            //         that.closeCalcNumPad()
            //     }
            // }
        })
        this.$el.find('.calc-input').off('click.inputClick').on('click.inputClick', function(e){
            if(isA11yCheckVersion()){
                e.stopPropagation();
                e.preventDefault();

                Popup.a11yDetctClosePopup();
            }

            that.defaults.activeIndex = $(this).attr('calc-input-num');
            that.openCalcNumPad(that.defaults.activeIndex);
            that.activeInputEvent(that.defaults.activeIndex);
            that.chageInputEvent();
            that.nextBtnCheck(that.defaults.activeIndex);
            that.btnDeleteChk();

            if(isA11yCheckVersion()){
                that.a11yFocus({type:'default', index: that.defaults.activeIndex});
            }
        })
        
        this.$el.on('click', function(e){
            if (!$(e.target).parents('.input-txt-group').hasClass('calc-input') && !$(e.target).parents('.calc-numberpad').hasClass('on')) {
                that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`).find('.btn-delete-txt').addClass('hidden')
                that.closeCalcNumPad();
            }
        });

        /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
        if(isA11yCheckVersion()){
            this.$el?.find('.numberpad-close-btn').off(`click${this.eventId}`).on(`click${this.eventId}`, (e)=> {
                e.stopPropagation();
                e.preventDefault();

                Popup.a11yDetctClosePopup();
                
                this.$el?.find('.input-txt-group').attr('tabindex','0').eq(that.defaults.activeIndex).focus();
                this.$el?.trigger('click');
            });

            
        }
        /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
    }
    activeInputEvent(index) {
        const $numberPad = this.$el.find('.calc-numberpad');
        const $activeInput = this.$el.find(`[calc-input-num="${index}"]`);
        // $numberPad.find('.focus-txt').attr('calc-title')  // 240527 제외  접근성작업

        //$numberPad.find('.focus-txt').focus(); // 240527 제외  접근성작업
        $numberPad.find('.numberpad-close-btn').focus();// 240527 제외  접근성작업

        if (this.$el.find('[input-check="true"]').length < this.defaults.calcInpLen-1) {
            $numberPad.find('.txt').text('다음');
        }else {
            if (this.$el.find('[input-check="true"]').length == this.defaults.calcInpLen-1 && $activeInput.attr('input-check') == 'true') {
                $numberPad.find('.txt').text('다음');
            } else {
                $numberPad.find('.txt').text('계산하기');
            }
        }
        this.$el.find('.calc-input').each(function(idx,element){
            $(element).removeClass('active');
        });
        this.defaults.activeIndex = index;
        $activeInput.addClass('active')
        $numberPad.attr('calc-numpad-num', this.defaults.activeIndex);

        /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
        if(isA11yCheckVersion()){
            this.a11yNumPadCaption();
            this.a11yLiveText();
            
            /* s: 공모주 키패드 접근성 텍스트값 초기화 */
            this.$el?.data('ui')?.render();
            this.a11yFocus({type:'default', index});
            /* e: 공모주 키패드 접근성 텍스트값 초기화 */
        }
        /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
    }
    openCalcNumPad(index){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        const gsapTm = gsap.timeline();
        if (!$numberPad.hasClass('on')) {
            gsapTm.fromTo($numberPad,
                {display: 'flex', autoAlpha: 0.6, yPercent: 10},
                {
                    delay: 0, duration: 0.2,yPercent:0, autoAlpha: 1, ease: 'linear',
                    onStart: () => {
                        $numberPad.scrollTop(0);
                    },
                    onComplete: () => {
                        $numberPad.css({transform: 'none'});
                        $numberPad.addClass('on');
                        $numberPad.find('.numberpad-close-btn').focus();
                        //$numberPad.find('.focus-txt').focus();
                        $numberPad.attr('calc-numpad-num', index)
                        that.nextStepEvent();
                    }
                },
            0);
        }
    }
    closeCalcNumPad(nextIndex){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        const gsapTm = gsap.timeline();
        if ($numberPad.hasClass('on')) {

            gsapTm.to($numberPad, {
                duration: 0.1, autoAlpha: 0, yPercent: 3, ease: Power0.easeOut, onComplete: () => {
                    gsap.set($numberPad, {display: 'none'});
                    $numberPad.removeClass('on')
                    that.$el.find('.calc-input').each(function(idx,element){
                        $(element).removeClass('active');
                    });
                    that.$el.find(`[calc-input-num="${nextIndex}"]`).focus()
                    //callback && callback();
                }
            }, 0);
        }
    }

    chageInputEvent(){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        const getData = this.inputGroupTitle;  // A11YTASK-222 : 접근성대응(2025-03-18)
        
        let numValue = '';
        $numberPad.find('button:not(.btn-lv01)').off('click.numBtn').on('click.numBtn', function(){
            const activeInput = that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`)
            const _thisStr = $(this).attr('data-num-str')
           
            if (activeInput.find('input').val() == '') {
                numValue = ''
            } else {
                numValue = activeInput.find('input').val();
            }
            if (_thisStr !== 'del' && _thisStr != undefined) {
                if (activeInput.find('input').val().length == 0 && (_thisStr == '0' || _thisStr == '00')) {
                    return false
                }
                numValue = numValue + _thisStr;
            } else {
                numValue = numValue.substring(0, numValue.length - 1)
            }
            if (activeInput.find('input').next('.btn-delete-txt').length <= 0) {
                activeInput.find('input').after(getInputButtonClose());
            }

            activeInput.find('input').val(numValue).attr('value',numValue);
            if (activeInput.attr('type-count') != undefined) {
                that.countTxt(numValue);
            }
            activeInput.find('.fake-input .txt').text(that.commaSet(numValue));

            const _titleStr = activeInput.attr('title');
            
            if (activeInput.find('input').val() == '') {
                activeInput.removeClass('done');
                activeInput.attr('input-check', false);
                that.validation(that.defaults.activeIndex,false)
                that.btnDeleteChk()
                // A11YTASK-222 : 접근성대응(2025-03-18)
                activeInput.attr('title', getData[`${that.defaults.activeIndex}`]);
                activeInput.removeAttr('aria-label');
            } else {
                activeInput.addClass('done');
                //that.validation(that.defaults.activeIndex,true)
                that.btnDeleteChk()
                // A11YTASK-222 : 접근성대응(2025-03-18)
                activeInput.removeAttr('title');
               
            }
            //that.nextBtnCheck(that.defaults.activeIndex)

            /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
            if(isA11yCheckVersion()){
                const inputIdx = Number(that.defaults.activeIndex);
                
                that.a11yChangeValueText(activeInput, numValue, inputIdx);

                // A11YTASK-504 : 접근성 대응 (2025.05.19)
                that.$el.find('.calc-input').each(function(index,element){
                    if ($(element).find('input').val() != ''){
                        const inputValue = $(element).find('input').val();
                        const numCommaVal = that.commaSet(inputValue);
                        const inputRightTxt = $(element).find('.txt-field').text();
                       
                        // 250620 A11YTASK-640 주석처리
                        // $(element).attr('aria-label', numCommaVal + inputRightTxt +' '+ that.inputGroupTitle[index] ); //A11YTASK-504 : 접근성대응(2025-05-09)

                        // 250620 A11YTASK-640 aria-label 함수 호출
                        that.addAriaLabel($(element),index,numCommaVal+inputRightTxt+' ');
                    } else{
                        // 250620 A11YTASK-640 주석처리
                        // $(element).removeAttr('aria-label');

                        // 250620 A11YTASK-640 aria-label 함수 호출
                        that.addAriaLabel($(element),index);
                    }
                })
            }
            /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
            if(isA11yCheckVersion()){
                if (activeInput.find('.btn-delete-txt').length > 0 ){
                    activeInput.find('.btn-delete-txt').remove();
                }
            }
        })

        // A11YTASK-504 : 접근성 대응 (2025.05.19)
        if(isA11yCheckVersion()){
            console.log('chageInputEvent')
            this.$el.find('.calc-input').each(function(index,element){
                if ($(element).find('input').val() != ''){
                    const inputValue = $(element).find('input').val();
                    const numCommaVal = that.commaSet(inputValue);
                    const inputRightTxt = $(element).find('.txt-field').text();
                    
                    // $(element).attr('aria-label', numCommaVal + inputRightTxt +' '+ that.inputGroupTitle[index] );

                    // 250620 A11YTASK-640 aria-label 함수 호출
                    that.addAriaLabel($(element),index,numCommaVal+inputRightTxt+' ');
                } else{
                    // $(element).removeAttr('aria-label');
                    
                    // 250620 A11YTASK-640 aria-label 함수 호출
                    that.addAriaLabel($(element),index);
                }
            })
        }
    }
    countTxt(value){
        const activeInput = this.$el.find(`[calc-input-num="${this.defaults.activeIndex}"]`)
        const activeFormRow = activeInput.closest('.form-row')
        if (activeInput.find('input').val() != '') {
            activeFormRow.find('.form-util .helper-msg').hide();
            activeFormRow.find('.form-util')
            if (!activeFormRow.find('.form-util .count-txt').length > 0) {
                activeFormRow.find('.form-util').append('<div class="count-txt"></div>');
            }
            activeFormRow.find('.form-util .count-txt').text(this.unitSet(value))
        } else {
            activeFormRow.find('.form-util .count-txt').remove();
            activeFormRow.find('.form-util .helper-msg').show();
        }
    }
    btnDeleteChk(index){
        const that =this;
        const calcInput = this.$el.find(`[calc-input-num]`)
        calcInput.each(function(idx,element){
            if ($(element).find('.btn-delete-txt').length > 0){
                if ($(element).hasClass('active') && $(element).find('input').val() != '') {
                    $(element).find('.btn-delete-txt').removeClass('hidden')
                } else{
                    $(element).find('.btn-delete-txt').addClass('hidden')
                }
            }
        })
        this.$el.find('.btn-delete-txt').off('click.btnDeleteTxt').on('click.btnDeleteTxt', function(e){
            e.stopPropagation()
            $(this).parent().find('input').val('').removeAttr('value')
            $(this).parent().find('.fake-input .txt').text('')
            $(this).addClass('hidden');
            $(this).parent().attr('input-check', false)
            $(this).parent().removeClass('done');
            that.validation(that.defaults.activeIndex, false)
            that.countTxt(0)
            that.nextBtnCheck($(this).parent().attr('calc-input-num'))

            /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
            if(isA11yCheckVersion()){
                const activeInput = that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`);
                activeInput.attr('aria-label', '');
            }
            /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
        })
    }
    nextBtnCheck(index){
        const activeInput = this.$el.find(`[calc-input-num="${index}"]`)
        let beforeIndex = index - 1;
        if (index == 0 ) {
            beforeIndex = this.defaults.calcInpLen - 1
        }
        
        const activeNumpad = $(`[calc-numpad-num="${index}"]`)
        if (activeInput.find('input').val() != '' && !activeInput.hasClass('error')) {
            activeInput.attr('input-check', true)
            if(isA11yCheckVersion()){
                activeInput.find('.btn-delete-txt').remove()
            } else {
                activeInput.find('.btn-delete-txt').removeClass('hidden')
            }
            
            activeNumpad.find('.popup-footer button').removeAttr('disabled');
            if (this.$el.find('[input-check="true"]').length === this.defaults.calcInpLen) {
                activeNumpad.find('.popup-footer button').addClass('primary1')
            }
            //activeNumpad.find('.popup-footer button').removeClass('disabled');
            //activeNumpad.find('.popup-footer button').removeAttr('disabled');
        } else {
            activeInput.attr('input-check', false)
            activeNumpad.find('.popup-footer button').removeClass('primary1')
            if (this.$el.find('[input-check="true"]').length === this.defaults.calcInpLen -1) {
                activeNumpad.find('.popup-footer button').attr('disabled', 'disabled');
            }
            //activeNumpad.find('.popup-footer button').addClass('disabled');
        }
        this.$el.find(`[calc-input-num="${beforeIndex}"]`).find('.btn-delete-txt').addClass('hidden')
        if (activeInput.hasClass('active') && activeInput.find('input').val() != '') {
            if(isA11yCheckVersion()){
                activeInput.find('.btn-delete-txt').remove()
            } else {
                activeInput.find('.btn-delete-txt').removeClass('hidden')
            }
        }
    }
    nextStepEvent(){
        const that = this;
        const $numberPad = this.$el.find('.calc-numberpad');
        
        if(isA11yCheckVersion()){
            $numberPad.find('.popup-footer button').off('click.nextBtn').on('click.nextBtn', function(e){
                e.stopPropagation();
                e.preventDefault();

                if ($numberPad.find('.txt').text() === '계산하기') {
                    that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`).find('.btn-delete-txt').addClass('hidden')
                    that.closeCalcNumPad();
                    that.calcCallBackAction();
                } else {
                    let nextIndex = Number(that.defaults.activeIndex)+1
                    if (nextIndex > that.defaults.calcInpLen-1) {
                        nextIndex = 0
                    }
                    that.activeInputEvent(nextIndex)
                    that.nextBtnCheck(nextIndex)
                    
                    /*! s: FETASK-a11y calculator 수정 v.1.0.0 */
                    if(isA11yCheckVersion()){
                        that.a11yFocus({type:'next', index:that.defaults.activeIndex});
                    }
                    /*! e: FETASK-a11y calculator 수정 v.1.0.0 */
                    that.closeCalcNumPad(nextIndex);  // 240527 제외  접근성작업
                }
            })
        }else{
            $numberPad.find('.popup-footer button').off('click.nextBtn').on('click.nextBtn', function(){
                if ($numberPad.find('.txt').text() === '계산하기') {
                    that.$el.find(`[calc-input-num="${that.defaults.activeIndex}"]`).find('.btn-delete-txt').addClass('hidden')
                    that.closeCalcNumPad();
                    that.calcCallBackAction();
                } else {
                    let nextIndex = Number(that.defaults.activeIndex)+1
                    if (nextIndex > that.defaults.calcInpLen-1) {
                        nextIndex = 0
                    }
                    that.activeInputEvent(nextIndex)
                    that.nextBtnCheck(nextIndex)
                }
            })
        }
    }
    validation(index, error, errorMsg){
        const ativeInput = this.$el.find(`[calc-input-num="${index}"]`);
        const ativeFormRow = ativeInput.closest('.form-row');
        if (error == 'error') {
            ativeInput.addClass('error');
            ativeFormRow.find('.form-util').addClass('error');
            this.$el.find(`[calc-input-num="${index}"]`).attr('input-check', false);
            if (ativeFormRow.find('.form-util .valid-msg.error').length > 0) {
                ativeFormRow.find('.form-util .valid-msg.error').text(errorMsg)
            } else {
                ativeFormRow.find('.form-util').append(`<div class="valid-msg error">${errorMsg}</div>
                </div>`)
            }
            if (ativeFormRow.find('.form-util .count-txt').length > 0) {
                ativeFormRow.find('.form-util .count-txt').hide();
            }
        }else {
            ativeInput.removeClass('error');
            ativeFormRow.find('.form-util').removeClass('error');
            if (ativeFormRow.find('.form-util .count-txt').length > 0) {
                ativeFormRow.find('.form-util .count-txt').show();
            }
            ativeFormRow.find('.form-util .valid-msg.error').remove();
        }
        this.nextBtnCheck(index)
        this.calcValiCallBackAction()
    }
    commaSet(num){
        let len, point, str;
        num = num + "";
        point = num.length % 3;
        len = num.length;

        str = num.substring(0, point);
        while (point < len){
            if (str != "") str += ",";
            str += num.substring(point, point+3);
            point += 3;
        }
        return str
    }
    unitSet(num) { //숫자 한글단위 추가를 위한 분리
        const that = this;
        const tempVal = num.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");
        const tempArr = tempVal.split(',').reverse();
        const unitArr = ["", "만", "억", "조", "경"];
        const maxUnitString = unitArr.length;
        let unitText = tempArr.map((v, i) => {
            if (i < maxUnitString && Number(v) > 0) return `${that.commaSet(v)}${unitArr[i]}`;
        }).reverse().join(' ').trim();
        return (unitText ? unitText : "0") + "원";
    }
    /**
    * calcAfterCallBack : 계산기 버튼 클릭 이후 콜백
    * @param {function} callback
    * @example 
    * $('.ui-calc').data('ui').calcAfterCallBack(function(){});
    */
    calcAfterCallBack(callback) {
        this.callback = callback;
    }
    calcCallBackAction() {
        if (this.callback && $.isFunction(this.callback)) {
            this.callback(this);
        }
    }
    /**
    * calcValiCallBack : 계산기 벨리데이션 이후 콜백 
    * @param {function} callback
    * @example 
    * $('.ui-calc').data('ui').calcValiCallBack(function(){});
    */
    calcValiCallBack(valiCallback) {
        this.valiCallback = valiCallback;
    }
    calcValiCallBackAction() {
        if (this.valiCallback && $.isFunction(this.valiCallback)) {
            this.valiCallback(this);
        }
    }
    async a11yFocus({type, index}){
        //안드로이드 텍스트 이상하게 읽히는 버그 수정
        $('.popup-calc.calc-numberpad').attr({'role': 'presentation none'}) //role="presentation none"
        $('.popup-calc.calc-numberpad').find('input[type="hidden"]').attr({'aria-hidden': 'true'});

        


        let targetTitle = null;

        let labelText= null;

        let resText = '';

        let delayTime = null;
        
        $('.calc-input').each((idx, _) => {
            if(index === idx) {
                targetTitle = $(`[calc-input-num="${idx}"]`)?.attr('aria-label') === '' ? $(`[calc-input-num="${idx}"]`)?.attr('title') : $(`[calc-input-num="${idx}"]`)?.attr('aria-label');
        
                labelText= $(`[calc-input-num="${idx}"]`)?.attr('aria-label') === '' ? '' : $(`[calc-input-num="${idx}"]`).find('label').text();
                
                resText = `${labelText} ${targetTitle}`;
            }
        });


        // if(type === 'default' || type === 'next'){   // 240527 제외  접근성작업
        //     this.$el.find('.calc-numberpad.popup-calc .close-btn').focus();
        // }

        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        // if(type === 'default' || type === 'next'){// 240527 제외  접근성작업
        //     //ios 버그
        //     console.log('#######')
        //     this.$el.find('.calc-numberpad.popup-calc .close-btn').focus();
        // }

        /*
        if(type === 'next'){
            this.$el.find('.calc-numberpad.popup-calc .close-btn').focus();
        }
        */

        const calcDiv = document.querySelector('.calc-live');
        const createText = document.createElement('div');

        if(document.querySelectorAll('.calc-live')?.length === 1){
            createText.innerText = `${resText}`;
            calcDiv.append(createText);
        }

        const delay1 = new Promise((resolve) => setTimeout(resolve, 400));

        await delay1;

        const delay2 = new Promise((resolve) => setTimeout(resolve, delayTime));

        await delay2;

        if(document.querySelectorAll('.calc-live')?.length === 1){
            createText.remove();
        }
    }
    a11yNumPadCaption(){
        //캡션 영역에 키패드 문구
        const $numberPad = this.$el.find('.calc-numberpad');
        const numPadCaption = $numberPad?.find('.keypad-table > caption');
        const numInputHiddenEles = $numberPad.find(`[calc-input-hidden="${this.defaults.activeIndex || 0}"]`);
        const numValue = numInputHiddenEles[0]?.attributes['calc-title']?.nodeValue || '';
        
        numPadCaption.text(`${numValue} keypad`);
    }
    a11yLiveText(){
        if(!document.querySelectorAll('.calc-live')?.length){
            const liveDiv = document.createElement('div');
            liveDiv.setAttribute('aria-live','polite');
            liveDiv.setAttribute('aria-atomic','false');
            liveDiv.setAttribute('aria-relevant','additions text');
            liveDiv.classList.add('calc-live');
            document.querySelector('body').append(liveDiv);
        }
    }
    a11yChangeValueText(target, value, index){
        if(index === 0){
            target.attr('aria-label', `${this.commaSet(value)}원`);
        }else if(index === 1){
            target.attr('aria-label', `${value}%`);
        }else if(index === 2){
            target.attr('aria-label', `${value}:1`);
        }else if(index === 3){
            target.attr('aria-label', `${this.commaSet(value)}원`);
        }
    }
}

export default Calculator;